import { Controller } from '@hotwired/stimulus'

// Toggles player photo field based on sponsor category.
export default class extends Controller {
  static targets = ['category', 'playerPhoto']

  connect() {
    this.update()
  }

  update() {
    const show = this.categoryTarget.value === 'player'
    this.playerPhotoTarget.classList.toggle('hidden', !show)
  }
}
